import React from "react";

interface IframeworkWinDrop {
    data: {}
}
export const frameworkWinDrop: IframeworkWinDrop = {
    data: {
        "COMPONENTS": [
            {
                "name": "winDropContainer",
                "type": "Container",
                //"anchor": [0.5, 0.5],
                "visible": true,
                "x": 0,
                "y": 0,
                "child": [
                    {
                        "id": "panelframe",
                        "name": "panelframe",
                        "image": "panelframe",
                        "type": "",
                        "width": 249,
                        "height": 58,
                        "visible": true,
                        "x": 0,
                        "y": 0
                    },
                    {
                        "id": "iconWP_1",
                        "name": "iconWP_1",
                        "image": "iconWP_1",
                        "type": "Image",
                        "width": 30,
                        "height": 30,
                        "visible": true,
                        "x": 20,
                        "y": 5
                    },
                   
                    {
                        "id": "multiplierTxt_0",
                        "name": "multiplierTxt_0",
                        "type": "Text",
                        "x": 85,
                        "y": 20,
                        "width": 100,
                        "visible": true,
                        "text": "0",
                        "scaleToFit": true,
                        "anchor": [0.5, 0.5],
                        "textStyle": {
                            fontFamily: 'impact',
                            fontSize: 36,
                            fontStyle: 'bold',
                            fill: ['#fec33b', '#cb3d02'],
                            dropShadow: true,
                            dropShadowColor: '#300f00',
                            dropShadowBlur: 2,
                            dropShadowAngle: Math.PI / 2,
                            dropShadowDistance: 6,


                        }
                    },
                    {
                        "id": "winAmountTxt_0",
                        "name": "winAmountTxt_0",
                        "type": "Text",
                        "x": 165,
                        "y": 20,
                        "width": 100,
                        "visible": true,
                        "text": "0",
                        "scaleToFit": true,
                        "anchor": [0.5, 0.5],
                        "textStyle": {
                            fontFamily: 'impact',
                            fontSize: 36,
                            fontStyle: 'bold',
                            fill: ['#fec33b'],
                            dropShadow: true,
                            dropShadowColor: '#300f00',
                            dropShadowBlur: 2,
                            dropShadowAngle: Math.PI / 2,
                            dropShadowDistance: 6,


                        }
                    },
                ],
            },
        ],
    }

};
export const winDropConfigurationContext = React.createContext(
    {}
);